import type { RfidMatrixRow } from '../types/rfid'

export async function exportRfidIdentifiersToExcel(rows: RfidMatrixRow[]): Promise<void> {
  const ExcelJS = await import('exceljs')
  const workbook = new ExcelJS.Workbook()
  const sheet = workbook.addWorksheet('RFID Identifiers')

  sheet.columns = [
    { header: 'Item name', key: 'itemName', width: 28 },
    { header: 'SKU', key: 'sku', width: 18 },
    { header: 'Barcode', key: 'barcode', width: 18 },
    { header: 'Item identifier', key: 'itemCode', width: 16 },
    { header: 'Style', key: 'styleCode', width: 14 },
    { header: 'Color', key: 'colorName', width: 14 },
    { header: 'Color identifier', key: 'colorCode', width: 16 },
    { header: 'Size', key: 'sizeName', width: 12 },
    { header: 'Size identifier', key: 'sizeCode', width: 16 },
    { header: 'EPC base/prefix', key: 'epcBase', width: 30 },
  ]

  const headerRow = sheet.getRow(1)
  headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } }
  headerRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF0D9488' },
  }

  for (const row of rows) {
    sheet.addRow({
      itemName: row.itemName,
      sku: row.sku,
      barcode: row.barcode || '',
      itemCode: row.itemCode || '',
      styleCode: row.styleCode || '',
      colorName: row.colorName,
      colorCode: row.colorCode || '',
      sizeName: row.sizeName,
      sizeCode: row.sizeCode || '',
      epcBase: row.epcBase || '',
    })
  }

  const buffer = await workbook.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `rfid-identifiers-${new Date().toISOString().slice(0, 10)}.xlsx`
  link.click()
  URL.revokeObjectURL(url)
}
